/**
 * nav.js — in-page navigation helpers for the ClientWave360 landing page.
 */

/**
 * Smooth-scroll to an in-page anchor (e.g. "#contact"). Respects the section's
 * CSS scroll-margin-top so the fixed header never covers the target.
 * @param {string} href anchor href, e.g. "#contact" or "#top"
 * @param {Event} [e] optional event to preventDefault on
 */
export function scrollToHash(href, e) {
  if (typeof href !== 'string' || href.charAt(0) !== '#') return;
  if (e) e.preventDefault();
  const id = href.slice(1);
  const target = id ? document.getElementById(id) : null;
  if (id && !target) return;
  (target || document.scrollingElement || document.documentElement).scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
  if (!target) window.scrollTo({ top: 0, behavior: 'smooth' });
}
